import React from 'react';
import classnames from 'classnames';
import ArtStageArrowL from '../../Icons/ArtStageArrowL';
import ArtStageArrowR from '../../Icons/ArtStageArrowR';
import BackToStreamButton from '../BackToStreamButton';
import { DuperbrowsePaddle } from './DuperbrowsePaddle';
import { useDuperbrowseKeyboardNavigation } from '../hooks/useDuperbrowseKeyboardNavigation';
import { useDuperbrowseViewType } from '../DuperbrowseViewContext';
import s from './DuperbrowsePaddles.scss';
var DuperbrowsePaddles = function (_a) {
    var className = _a.className, paddleClassName = _a.paddleClassName, iconClassName = _a.iconClassName, enableKeyboardNavigation = _a.enableKeyboardNavigation, _b = _a.navigation, nextItem = _b.nextItem, prevItem = _b.prevItem, _c = _a.showBackTo, showBackTo = _c === void 0 ? true : _c, moveNext = _a.moveNext, movePrev = _a.movePrev;
    // if we are inside lightbox, we rely on the lightbox itself to provide the nav
    var isLightbox = useDuperbrowseViewType().isLightbox;
    useDuperbrowseKeyboardNavigation(enableKeyboardNavigation && !isLightbox);
    if (isLightbox) {
        return null;
    }
    return (React.createElement("div", { className: classnames(s['root'], className) },
        React.createElement(DuperbrowsePaddle, { isEnabled: !!prevItem, className: classnames(s['prev'], paddleClassName), onClick: movePrev, dataHook: "arrowL" },
            React.createElement(ArtStageArrowL, { customSizable: true, disableDefaultColors: true, className: classnames(s['icon'], iconClassName) })),
        showBackTo && React.createElement(BackToStreamButton, null),
        React.createElement(DuperbrowsePaddle, { isEnabled: !!nextItem, className: classnames(s['next'], paddleClassName), onClick: moveNext, dataHook: "arrowR" },
            React.createElement(ArtStageArrowR, { customSizable: true, disableDefaultColors: true, className: classnames(s['icon'], iconClassName) }))));
};
export default DuperbrowsePaddles;
//# sourceMappingURL=DuperbrowsePaddles.js.map